import React, { useEffect, useState } from "react";
import CommentList from "./CommentList/CommentList";
import PendingCommentList from "./PendingCommentList/PendingCommentList";
import { connect } from "react-redux";
import FsLightbox from "./FsLightbox/FsLightbox";
import {
  selectors,
  setSkip,
  setItem,
  setSortByStarred,
  setSortAscending,
  dismissError,
  setShowContributionsWithPhotos
} from "../app/slices/itemSlice";
import {
  getComments,
  getNewItem,
  getMedia,
  getImplementation,
} from "../app/API/commentAPI";
import Modal from "./Modal/Modal";
import AddContributionModal from "./Modals/AddContributionModal";
import AddContributionSection from "./AddContributionSection/AddContributionSection";
import SortHeader from "./SortHeader/SortHeader";
import { IsUserLoggedIn } from "../helpers/authHelper";
import {
  selectors as mediaSelectors,
  setMedia,
  setShowGallery,
} from "../app/slices/mediaSlice";
import PropTypes from "prop-types";
import LoadingSpinner from "./LoadingSpinner";
import LoadMoreButton from "./LoadMoreButton";
import { getProfileData } from '../app/API/profileAPI';
import { getUserProperties } from '../helpers/authHelper';
import { ItemPropType } from "../PropTypes";

function CommentSection(props) {
  const [showModal, setShowModal] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [profile, setProfile] = useState({});

  const { REACT_APP_SIGNINURL } = process.env;
  const {
    skip,
    top,
    setItem,
    sortAscending,
    sortByStarred,
    showContributionsWithPhotos, 
    sortPinned,
    reloadComments,
    item,
    setMedia,
    setSkip,
    showGallery,
    externalId,
    media,
    id,
  } = props;

  const user = getUserProperties();

  const closeRootModal = () => {
    setShowModal(false);
    window.removeEventListener('popstate', closeRootModal);
  };

  /**
   * Get the profile data
   * Used for determining whether the logged is an organisation user or not
   */
    useEffect(() => {
      (async () => {
        const response = await getProfileData(user?.userId);
        // Check if the response is valid
        if (response.isValid || response.isValid === undefined) {
          setProfile(response);
        }
      })();
    }, [user?.userId]);

  useEffect(() => {
    document.body.style.overflow = showModal ? 'hidden' : '';
    document.getElementsByTagName("html")[0].style.overflow = showModal ? 'hidden' : '';
    showModal && window.history.pushState({}, '');
    showModal && window.addEventListener('popstate', closeRootModal);
  }, [showModal]);

  useEffect(() => {
    // Get comments
    (async function () {
      let response = await getComments(
        props.implementationId,
        props.itemId,
        skip,
        top,
        sortAscending,
        sortByStarred,
        sortPinned,
        showContributionsWithPhotos
      );
      if (response.id === undefined) {
        response = await getNewItem(props.implementationId, props.itemId);
        if (response.implementation === undefined || response.implementation === null) {
          let implementationResponse = await getImplementation(
            props.implementationId
          );

          setItem({
            id: 0,
            externalId: "-1",
            comments: [],
            implementation: implementationResponse,
          });
          setPageLoaded(true);

          //TODO: display an error.
        }
      }

      if (response.id !== undefined) {
        setItem(response);
        setPageLoaded(true);
      }
    })();
  }, [
    props.implementationId,
    props.itemId,
    setItem,
    reloadComments,
    skip,
    top,
    sortByStarred,
    sortAscending,
    showContributionsWithPhotos
  ]);

  useEffect(() => {
    // get media items
    (async function () {
      const response = await getMedia(props.itemId);
      setMedia(response);
    })();
  }, [id, props.itemId, setMedia]);

  //The Modal component and AddContributionModal component are passed "confirmClose = {true}" so that a confirm close
  // modal message will display when trying to close it. This gives the ("X") button on the Modal itself and the
  // "Cancel" button on the model access to this feature
  return (
    <>
      {pageLoaded ? (
        <>
          {item.externalId !== "-1" ? (
            <>
              {showModal && (
                <Modal
                  closeRootModal={closeRootModal}
                  confirmClose={true}
                  dismissError={props.dismissError}
                >
                  <AddContributionModal
                    closeRootModal={closeRootModal}
                    confirmClose={true}
                    item={item}
                    allowMapOnModal={props.item.implementation.allowMapOnModal}
                  />
                </Modal>
              )}
              <h2 className="ugc-comments-list-section__title">
                {props.item?.implementation?.title ?? "Comments and Photos"}
              </h2>
              {/* At the comment section level we use the .active on the implementation to check if it is open or closed to contributions  */}
              {props.item.implementation.active ? (
                <AddContributionSection
                  setShowModal={setShowModal}
                  showModal={showModal}
                  isUserLoggedIn={IsUserLoggedIn()}
                  totalCommentsLength={props.totalComments}
                  validAddressForNewPin={true}
                  isOrganisation={profile.isOrganisation}
                  organisationName={profile.organisationName}
                />
              ) : (
                <p>
                  This discussion is now closed, all {props.item.totalComments}{" "}
                  comments are still available to view
                </p>
              )}
              {props.item.pendingComments ? (
                <PendingCommentList
                  item = {props.item}
                  comments={props.item.pendingComments}
                  externalId={props.item.externalId}
                  top={props.top}
                  skip={props.skip}
                  setSkip={props.setSkip}
                />
              ) : null}
              <SortHeader
                sortAscending={sortAscending}
                sortByStarred={sortByStarred}
                setAscending={props.setAscending}
                setSortByStarred={props.setSortByStarred}
                showContributionsWithPhotos={showContributionsWithPhotos}
                setShowContributionsWithPhotos={props.setShowContributionsWithPhotos}
                isUserLoggedIn={IsUserLoggedIn()}
              />
              <CommentList
                item={props.item}
                comments={props.item.comments}
                externalId={props.item.externalId}
                top={props.top}
                skip={props.skip}
                setSkip={props.setSkip}
                maxChars={props.maxChars}
              />

              <div className={`ugc-comments-list__footer ${props.item?.comments?.length === 0 && 'ugc-comments-list__footer--no-border'}`}>
                <div className="ugc-comments-list__footer-content">
                  {props.item.comments && props.moreComments ? (
                    <LoadMoreButton
                      top={top}
                      skip={skip}
                      setSkip={setSkip}/>
                  ) : (
                      <div className="ugc-comments-list__no-comments">
                      There aren't any {props.item.comments.length > 0 && "more"} comments
                    </div>
                  )}
                </div>
                {!IsUserLoggedIn() && (
                  <div className="ugc-comments-list__sign-in-prompt">
                    <a rel="nofollow"
                      href={`${REACT_APP_SIGNINURL}/?u=&referrer=${window.location}`}
                      data-component="ugcGoToLoginLinkBottom">
                      Sign in to comment
                    </a>
                  </div>
                )}
              </div>

              <FsLightbox
                showGallery={showGallery}
                externalId={externalId}
                media={media}
              />
            </>
          ) : (
            <>
              <h2 className="ugc-comments-list__error-heading">Oops! Something has gone wrong.</h2>
              <p>Please try again later.</p>
            </>
          )}
        </>
      ) : (
        <LoadingSpinner/>
      )}
    </>
  );
}

CommentSection.propTypes = {
  media: PropTypes.array,
  fetchMedia: PropTypes.func,
  setMedia: PropTypes.func,
  item: ItemPropType
};

const mapStateToProps = (state) => {
  return {
    skip: selectors.skip(state),
    top: selectors.top(state),
    item: selectors.item(state),
    sortAscending: selectors.sortAscending(state),
    sortByStarred: selectors.sortByStarred(state),
    showContributionsWithPhotos: selectors.showContributionsWithPhotos(state),
    sortPinned: selectors.sortPinned(state),
    maxChars: selectors.maxChars(state),
    moreComments: selectors.moreComments(state),
    reloadComments: selectors.reloadComments(state),
    totalComments: selectors.totalComments(state),
    media: mediaSelectors.media(state),
    showGallery: mediaSelectors.showGallery(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSkip: (skip) => dispatch(setSkip(skip)),
    setItem: (item) => dispatch(setItem(item)),
    setAscending: (value) => dispatch(setSortAscending(value)),
    setSortByStarred: (value) => dispatch(setSortByStarred(value)),
    setShowContributionsWithPhotos: (value) => dispatch(setShowContributionsWithPhotos(value)),
    setMedia: (media) => dispatch(setMedia(media)),
    setShowGallery: (value) => dispatch(setShowGallery(value)),
    dismissError: () => dispatch(dismissError()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentSection);
